// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uTtQ","fullView":"styles_fullView__3qag7"};